import { render, staticRenderFns } from "./mainSearchbarResultSection.vue?vue&type=template&id=2476b4da&scoped=true&"
import script from "./mainSearchbarResultSection.vue?vue&type=script&lang=js&"
export * from "./mainSearchbarResultSection.vue?vue&type=script&lang=js&"
import style0 from "./mainSearchbarResultSection.vue?vue&type=style&index=0&id=2476b4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476b4da",
  null
  
)

export default component.exports